import React from 'react';
import Delivery from './views/Delivery'
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import './App.css';

function App() {
  return (
    <div>
      <ToastContainer
        position="bottom-left" />
      <Delivery />
    </div>
  );
}

export default App;
